module.exports = __webpack_public_path__ + "a2f0d05576973b9267a7378203dbb4d8.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Ubuntu_Mono/UbuntuMono-BoldItalic.ttf
// module id = 375
// module chunks = 0